/*
 * AGOVIA chrome: overlay menu drawer + accordions.
 * Ported from the approved mockup's vanilla toggles (20 Aug 2026), with the
 * theme's accessibility additions: scroll lock, aria state, Escape, focus
 * return, and a reset on Shopify section re-render in the theme editor.
 *
 * 14 Sep 2026: the drawer now opens on desktop too (MENU button in .agv-hd)
 * and a scrim (.agv-scrim, also data-agv-tog) closes it on an outside click.
 * Accordions open on ONE click and stay open until clicked again or the
 * drawer closes; nothing in here reacts to hover (Jasper, 14 Sep).
 *
 * Desktop panel dropdowns (Nav A, still selectable in the section settings):
 * CSS :hover opens them, but JS PINS them open (.open) so they never vanish
 * on mouseleave (Jasper, 28 Aug). A pinned panel closes only when another
 * top-level item is entered, a link inside it is clicked, the pointer clicks
 * outside the nav, or Escape.
 *
 * 29 Sep 2026 (U4): the phone bar's Search link ([data-agv-search]) opens the
 * drawer and focuses its search field, synchronously inside the tap so iOS
 * raises the keyboard. Focus returns to Search when the drawer closes. With no
 * search field in the drawer, or a modified click, the link just navigates.
 */
(function () {
  var OPEN = 'nav-open';
  var DESKTOP = window.matchMedia('(min-width: 901px)');

  function scopeOf(el) { return el.closest('.agv-s'); }

  // The control to refocus on close when it was not the MENU button (the phone
  // Search link), provided it is still on screen. Cleared on every read.
  function takeReturn(scope) {
    var back = scope._agvReturn;
    scope._agvReturn = null;
    return back && back.offsetParent !== null ? back : null;
  }

  function setDrawer(scope, open) {
    scope.classList.toggle(OPEN, open);
    document.body.style.overflow = open ? 'hidden' : '';
    var drw = scope.querySelector('.agv-drw');
    if (drw) drw.setAttribute('aria-hidden', open ? 'false' : 'true');
    scope.querySelectorAll('[data-agv-tog][aria-controls]').forEach(function (b) {
      b.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
    if (open && drw) {
      // Desktop: land in the search field. Mobile: the CLOSE control, so the
      // keyboard does not pop over the menu.
      var first = DESKTOP.matches ? drw.querySelector('.agv-drwsearch input') : null;
      if (!first) first = drw.querySelector('[data-agv-tog], a');
      if (first) first.focus();
    }
    if (!open) {
      // Reset accordions so the next open starts collapsed.
      scope.querySelectorAll('.agv-drwrow.exp').forEach(function (row) {
        row.classList.remove('exp');
        var b = row.querySelector('[data-agv-acc]');
        if (b) { b.setAttribute('aria-expanded', 'false'); var cv = b.querySelector('.cv'); if (cv) cv.textContent = '+'; }
      });
    }
  }

  document.addEventListener('click', function (e) {
    var t = e.target.closest && e.target.closest('[data-agv-tog]');
    if (t) {
      e.preventDefault();
      var scope = scopeOf(t);
      if (scope) {
        var willOpen = !scope.classList.contains(OPEN);
        if (willOpen) scope._agvReturn = null;
        setDrawer(scope, willOpen);
        if (!willOpen) {
          var opener = takeReturn(scope) || scope.querySelector('.agv-hd [data-agv-tog], .agv-mbar [data-agv-tog]');
          if (opener && opener.offsetParent !== null) opener.focus();
        }
      }
      return;
    }
    var srch = e.target.closest && e.target.closest('[data-agv-search]');
    if (srch) {
      if (e.defaultPrevented || e.button || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
      var sScope = scopeOf(srch);
      var field = sScope && sScope.querySelector('.agv-drwsearch input');
      if (!field) return;
      e.preventDefault();
      if (!sScope.classList.contains(OPEN)) setDrawer(sScope, true);
      sScope._agvReturn = srch;
      field.focus();
      return;
    }
    var acc = e.target.closest && e.target.closest('[data-agv-acc]');
    if (acc) {
      e.preventDefault();
      var row = acc.parentElement;
      var open = row.classList.toggle('exp');
      acc.setAttribute('aria-expanded', open ? 'true' : 'false');
      var cv = acc.querySelector('.cv');
      if (cv) cv.textContent = open ? String.fromCharCode(8722) : '+';
    }
  });

  // Desktop panels (Nav A): hover pins, and only deliberate acts unpin.
  function unpinPanels(except) {
    document.querySelectorAll('.agv-ni.open').forEach(function (n) {
      if (n !== except) n.classList.remove('open');
    });
  }

  document.addEventListener('mouseover', function (e) {
    if (!e.target.closest) return;
    var nav = e.target.closest('.agv-nv');
    if (!nav) return;
    var item = e.target.closest('.agv-ni');
    if (item) {
      unpinPanels(item);
      item.classList.add('open');
    } else if (e.target.closest('.agv-nv > a')) {
      // entering a childless top-level link switches away from any open panel
      unpinPanels(null);
    }
  });

  document.addEventListener('click', function (e) {
    if (!e.target.closest) { unpinPanels(null); return; }
    if (e.target.closest('.agv-panel a')) { unpinPanels(null); return; }
    if (!e.target.closest('.agv-ni')) unpinPanels(null);
  });

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    unpinPanels(null);
    var openScope = document.querySelector('.agv-s.' + OPEN);
    if (openScope) {
      setDrawer(openScope, false);
      var opener = takeReturn(openScope) || openScope.querySelector('.agv-hd [data-agv-tog], .agv-mbar [data-agv-tog]');
      if (opener && opener.offsetParent === null) opener = openScope.querySelector('.agv-mbar [data-agv-tog]');
      if (opener) opener.focus();
      return;
    }
    // Close a hover/focus panel from the keyboard by dropping focus.
    var inPanel = document.activeElement && document.activeElement.closest &&
      document.activeElement.closest('.agv-ni');
    if (inPanel) document.activeElement.blur();
  });

  document.addEventListener('shopify:section:load', function () {
    document.querySelectorAll('.agv-s.' + OPEN).forEach(function (s) { setDrawer(s, false); });
    unpinPanels(null);
  });
})();
